import { render } from "./SystemSettings.vue?vue&type=template&id=928f1ea2&scoped=true"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"

import "./SystemSettings.vue?vue&type=style&index=0&id=928f1ea2&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928f1ea2"]])

export default __exports__